import { Wallet, Building, CreditCard } from 'lucide-react';

/**
 * Standard account types used across the application
 * Used in AddAccountModal, EditAccountModal, and other account management components
 */
export const accountTypes = [
  { value: 'brokerage', label: 'Brokerage Account', icon: Building },
  { value: 'bank', label: 'Bank Account', icon: Wallet },
  { value: 'cash', label: 'Cash', icon: Wallet },
  { value: 'checking', label: 'Checking Account', icon: Wallet },
  { value: 'savings', label: 'Savings Account', icon: Wallet },
  { value: 'retirement', label: 'Retirement Account', icon: CreditCard },
  { value: 'investment', label: 'Investment Account', icon: Building },
  { value: 'credit_card', label: 'Credit Card', icon: CreditCard },
  { value: 'loan', label: 'Loan Account', icon: CreditCard }
];

/**
 * Get account type label by value
 * @param {string} type - Account type value
 * @returns {string} - Human-readable label
 */
export const getAccountTypeLabel = (type) => {
  const labels = {
    'brokerage': 'Brokerage Account',
    'bank': 'Bank Account',
    'cash': 'Cash',
    'checking': 'Checking Account',
    'savings': 'Savings Account',
    'retirement': 'Retirement Account',
    'investment': 'Investment Account',
    'credit_card': 'Credit Card',
    'loan': 'Loan Account'
  };
  return labels[type] || 'Account';
};

/**
 * Get account icon component by type
 * @param {string} accountType - Account type value
 * @returns {React.Component} - Lucide icon component
 */
export const getAccountIcon = (accountType) => {
  switch (accountType) {
    case 'brokerage':
    case 'investment':
      return Building;
    case 'bank':
    case 'cash':
    case 'checking':
    case 'savings':
      return Wallet;
    case 'retirement':
    case 'credit_card':
    case 'loan':
      return CreditCard;
    default:
      return Wallet;
  }
};
